<template>
    <div>
        <el-dialog class="dialog" :title="juesequanxianlisttitle" v-if="juesequanxianlist" :visible.sync="juesequanxianlist" width="80%" top="10vh">
            <el-tabs v-model="fenzuquanxian" type="card" @tab-click="handleClick">

                <el-tab-pane label="角色权限" name="1">
                    <roles-table ref="role" v-if="fenzuquanxian == '1'" @getAgainList="getList(jueseinfo)" @handleAddRoles="handleAddRoles"></roles-table>
                </el-tab-pane>

                <el-tab-pane label="用户列表" name="2">
                    <group-table ref="group" v-if="fenzuquanxian == '2'" @getAgainList="getList(jueseinfo)" @handleAddGroups="handleAddGroups"></group-table>
                </el-tab-pane>

            </el-tabs>
        </el-dialog>
    </div>
</template>

<script>
import RolesTable from './rolesTable'
import GroupTable from './groupTable'
import {roleinfo} from '@Sys~/api/sys'
export default {
    components: {RolesTable, GroupTable},
    data() {
        return {
            juesequanxianlisttitle: '', // 标题
            juesequanxianlist: false,
            fenzuquanxian: '1',
            userList: [], // 用户数据
            groupList: [], // 分组数据
            jueseinfo:{} // 详情 row
        }
    },

    methods: {
        init(row) {
            this.jueseinfo = row
            this.juesequanxianlisttitle = "角色权限表：" + row.title // 标题
            this.juesequanxianlist = true
            this.fenzuquanxian = '1'
            this.getList(row)
        },

        // 切换
        handleClick() {
            if(this.fenzuquanxian == '1') {
                this.$nextTick(() => {
                    this.$refs['role'].init(this.jueseinfo, this.userList)
                })
            } else {
                this.$nextTick(() => {
                    this.$refs['group'].init(this.jueseinfo, this.groupList)
                })
            }
        },
      
        // 获取详情数据
        getList(row) {
            this.handleClick()
            // roleinfo(row.id).then(response => {
            //     if (response.code == 1) {
            //         this.userList = response.data.permissions
            //         this.groupList = response.data.users
            //         this.handleClick()
            //     }
            // });
        },

        // 添加用户权限
        handleAddRoles() {
            this.$emit('handleAddRoles',this.jueseinfo)
        },

        // 添加用户组
        handleAddGroups() {
            this.$emit('handleAddGroups',this.jueseinfo)
        }
    }
}
</script>

<style lang="scss" scoped>
    .dialog{
        ::v-deep .el-dialog__body{
            padding: 8px 20px 15px;
        }
    }
</style>